import React, { createContext, useContext, useState } from "react";

const CurrencyContext = createContext();
export const useCurrency = () => useContext(CurrencyContext);

export function CurrencyProvider({ children }) {
  const [primary, setPrimary] = useState("GHS"); // GHS | GBP

  const format = (ghs, gbp) => {
    const ghsStr = `GH₵ ${Number(ghs).toLocaleString()}`;
    const gbpStr = `£${Number(gbp).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    return primary === "GHS" ? { main: ghsStr, sub: gbpStr } : { main: gbpStr, sub: ghsStr };
  };

  return (
    <CurrencyContext.Provider value={{ primary, setPrimary, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}
